import styled from 'styled-components'
import Modal from 'styled-react-modal'

export const Container = Modal.styled`
  display: flex;
  flex-direction: column;
  width: 560px;
  max-width: 92vw;
  background: #FFFFFF;                 /* fundo liso */
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(0,0,0,0.18);
  padding: 24px 24px 16px;             /* respiro interno único */
  overflow: visible;                    /* nada de scroll interno */
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;                            /* espaços entre campos */
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #495057;
`

export const TextArea = styled.textarea`
  width: 100%;
  max-width: 100%;
  min-height: 120px;                    /* tamanho confortável */
  padding: 12px;
  border: 1px solid #CED4DA;           /* mesma família dos inputs padrão */
  border-radius: 8px;
  background: #fff;
  font: inherit;
  resize: vertical;
  box-sizing: border-box;               /* nunca ultrapassa a modal */
`

export const Footer = styled.div`
  margin-top: 16px;                     /* separa dos campos */
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`
